module.exports = __webpack_public_path__ + "static/media/Terms and conditions.6f33ffd0.pdf";